import "./records-user-sotr.css";

/** Хинт для сотрудника */
const RecordsUserSotr = ({ user, qty, calendars }) => {
  const img = user.imageId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${user.imageId}.jpg` : "/images/user.svg";
  const calendarName = calendars?.find(c => c.value === user.calendarId)?.label || (user.calendarId ? `Календарь #${user.calendarId}` : 'Календарь не указан');
  
  return (
    <div className="records-user-sotr">
      <div className="records-user-sotr-header">
        <img src={img} alt="user" className="records-user-sotr-icon" />
        <div>
          <div className="records-user-sotr-title">{user.name}</div>
          {user.position && <div className="records-user-sotr-description">{user.position}</div>}
          <div className="records-user-sotr-calendar">{calendarName}</div>
        </div>
      </div>
      <div className="records-user-sotr-stats">
        <div>Всего записей {user.totalRecords || qty || 0}</div>
      </div>
    </div>
  );
};

export default RecordsUserSotr;

